import Vue from 'vue'
import Main from './modules/Main'

const app = new Vue({
  el: '#app',
  render: (h) => h(Main),
  data () {
    return {
      lang: 'en'
    }
  },
  methods: {
    changeLanguage (lang) {
      this.lang = lang
    }
  }
})

window.app = app
